import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const CompleteIcon = (props) => <FontAwesomeIcon icon={faCheck} {...props} />;

export default CompleteIcon;
